import {
    trigger,
    transition,
    style,
    query,
    group,
    animate,
    animateChild,
} from '@angular/animations';

/**
 * Route animations for smooth page transitions
 * 
 * Usage: Add [@routeAnimations]="getRouteAnimationData()" to your router-outlet wrapper
 */
export const routeAnimations = trigger('routeAnimations', [
    transition('* <=> *', [
        style({ position: 'relative' }),
        query(
            ':enter, :leave',
            [
                style({
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                }),
            ],
            { optional: true }
        ),
        query(':enter', [style({ opacity: 0 })], { optional: true }),
        group([
            query(
                ':leave',
                [animate('250ms ease-out', style({ opacity: 0 }))],
                { optional: true }
            ),
            query(
                ':enter',
                [animate('400ms ease-in', style({ opacity: 1 }))],
                { optional: true }
            ),
        ]),
    ]),
    // transition('* <=> *', [
    //     style({ position: 'relative' }),
    //     query(
    //         ':enter, :leave',
    //         [
    //             style({
    //                 position: 'absolute',
    //                 top: 0,
    //                 left: 0,
    //                 width: '100%',
    //             }),
    //         ],
    //         { optional: true }
    //     ),
    //     query(':enter', [style({ opacity: 0 })], { optional: true }),
    //     query(':leave', animateChild(), { optional: true }),
    //     group([
    //         query(
    //             ':leave',
    //             [
    //                 animate(
    //                     '300ms ease-out',
    //                     style({
    //                         opacity: 0,
    //                         transform: 'translateX(-50px)',
    //                     })
    //                 ),
    //             ],
    //             { optional: true }
    //         ),
    //         query(
    //             ':enter',
    //             [
    //                 animate(
    //                     '300ms ease-out',
    //                     style({
    //                         opacity: 1,
    //                         transform: 'translateX(0)',
    //                     })
    //                 ),
    //             ],
    //             { optional: true }
    //         ),
    //     ]),
    //     query(':enter', animateChild(), { optional: true }),
    // ]),
]);

/**
 * Simpler fade animation for subtle transitions
 */
export const fadeAnimation = trigger('fadeAnimation', [
    transition('* <=> *', [
        style({ position: 'relative' }),
        query(
            ':enter, :leave',
            [
                style({
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                }),
            ],
            { optional: true }
        ),
        query(':enter', [style({ opacity: 0 })], { optional: true }),
        group([
            query(
                ':leave',
                [animate('200ms ease-out', style({ opacity: 0 }))],
                { optional: true }
            ),
            query(
                ':enter',
                [animate('200ms ease-out', style({ opacity: 1 }))],
                { optional: true }
            ),
        ]),
    ]),
]);

/**
 * Slide animation for directional transitions
 */
export const slideAnimation = trigger('slideAnimation', [
    transition('* => *', [
        style({ position: 'relative' }),
        query(
            ':enter, :leave',
            [
                style({
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                }),
            ],
            { optional: true }
        ),
        query(':enter', [style({ transform: 'translateX(100%)' })], {
            optional: true,
        }),
        group([
            query(
                ':leave',
                [
                    animate(
                        '400ms ease-in-out',
                        style({ transform: 'translateX(-100%)' })
                    ),
                ],
                { optional: true }
            ),
            query(
                ':enter',
                [animate('400ms ease-in-out', style({ transform: 'translateX(0)' }))],
                { optional: true }
            ),
        ]),
    ]),
]);

